import { FromToDate } from '@imcc/utilities';
import { FilterAggregation } from './filter-aggregation.interface';

export const initialState = Object.freeze({
  showFilters: true,
  active: {},
  expanded: [],
  aggregations: [],
});

export class FilterTabState {
  showFilters: boolean;

  active: {
    [term: string]: string[] | FromToDate;
  };

  expanded: string[];

  aggregations: FilterAggregation[];
}
